import { FeedbackType } from "types/enums";
import actionCreatorFactory from "../util/redux/action-factory";
import { reducerWithInitialState } from "util/redux/typed-reducers";
import * as request from "../util/request";
import { env } from "util/env";
import {
    PromptFeedbackFeatureRequest,
    PromptFeedbackFeatureResponse,
    PostFeedbackFeatureRequest,
    PostFeedbackFeatureResponse,
} from "util/DTOs/FeedbackFeatureDtos";
import { ReduxDispatch } from "./reducers";
import { showSnackbar } from "./snackbar";

const actionFactory = actionCreatorFactory("HypoMobiili/Feedback-feature");

const shouldPromptFeedbackFeatureAction = actionFactory<
    PromptFeedbackFeatureRequest,
    PromptFeedbackFeatureResponse,
    string
>("SHOULD_PROMPT_FEEDBACK_FEATURE");

const postFeatureFeedbackAction = actionFactory<
    PostFeedbackFeatureRequest,
    PostFeedbackFeatureResponse,
    string
>("SEND_FEEDBACK_FEATURE");

const closeFeatureFeedbackDialogAction = actionFactory<
    { closeDialog: boolean },
    { closeDialog: boolean },
    string
>("CLOSE_FEEDBACK_FEATURE_DIALOG");

export const checkShouldPromptFeedbackFeature = () => {
    return async (dispatch: ReduxDispatch) => {
        try {
            const result = await request.get<PromptFeedbackFeatureResponse>(
                `${env.APP_API_HOST}/api/feedback/featureUsage/checkShouldPromptFeedback`
            );

            dispatch(shouldPromptFeedbackFeatureAction.done(result));
        } catch (error) {
            // Payload ignored in reducer
            dispatch(shouldPromptFeedbackFeatureAction.failed("error"));
            throw error;
        }
    };
};

export const sendFeedbackFeature = (
    comment: string,
    score: number,
    feature: FeedbackType
) => {
    return async (dispatch: ReduxDispatch) => {
        const payload: PostFeedbackFeatureRequest = { comment, score, feature };
        try {
            const result = await request.post<PostFeedbackFeatureResponse>(
                `${env.APP_API_HOST}/api/feedback/featureUsage/postFeatureFeedback`,
                payload
            );

            dispatch(postFeatureFeedbackAction.done(result));
            dispatch(showSnackbar("Palaute lähetetty"));
        } catch (error) {
            dispatch(showSnackbar("Palautteen lähettäminen epäonnistui"));
            // Payload ignored in reducer
            dispatch(postFeatureFeedbackAction.failed("error"));
        }
    };
};

export const closeFeedbackFeatureDialog = (closeDialog: boolean) => {
    return (dispatch: ReduxDispatch) => {
        dispatch(closeFeatureFeedbackDialogAction.done({ closeDialog }));
    };
};
export interface FeedbackFeatureState {
    feature?: FeedbackType;
    shouldPrompt: boolean;
}

const initialFeedbackFeatureState: FeedbackFeatureState = {
    feature: undefined,
    shouldPrompt: false,
};

const FeedbackFeatureReducer = reducerWithInitialState(
    initialFeedbackFeatureState
)
    .case(shouldPromptFeedbackFeatureAction.done, (state, action) => {
        return {
            ...state,
            feature: action.payload.feature,
            shouldPrompt: action.payload.shouldPrompt,
        };
    })
    .case(shouldPromptFeedbackFeatureAction.failed, (state, _action) => {
        return {
            ...state,
            shouldPrompt: false,
            feature: undefined,
        };
    })
    .case(postFeatureFeedbackAction.done, (state, action) => {
        return {
            ...state,
            shouldPrompt: !action.payload.isSuccess,
            feature: undefined,
        };
    })
    .case(postFeatureFeedbackAction.failed, (state, _action) => {
        return {
            ...state,
            shouldPrompt: false,
            feature: undefined,
        };
    })
    .case(closeFeatureFeedbackDialogAction.done, (state, action) => {
        return {
            ...state,
            shouldPrompt: !action.payload.closeDialog,
        };
    });

export default FeedbackFeatureReducer;



// WEBPACK FOOTER //
// ./src/ducks/feedbackFeature.ts